import { Head } from 'components/Head';
import { MainLayout } from 'components/Layout';
import { useEffect } from 'react';

export const DeleteAccount = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // change to 'auto' if you want instant
    });
  }, []);
  return (
    <MainLayout
      title="Delete Account | Fundo"
      description="Request deletion of your Fundo account and associated data."
    >
      <section className="mx-auto max-w-3xl py-20">
        {/* Header */}
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.35em] text-[#8b5e3c]">
            Account Management
          </p>

          <h1 className="mt-4 font-serif text-5xl leading-[0.95] tracking-[-0.04em] text-[#1b140f]">
            Delete your account
          </h1>

          <p className="mt-6 text-[#4f4034] leading-8">
            We're sorry to see you go. If you would like to permanently delete your Fundo account
            and associated data, follow the instructions below.
          </p>
        </div>

        {/* Instructions Card */}
        <div className="mt-10 rounded-[1.75rem] border border-[#1b140f]/10 bg-white/60 p-8 backdrop-blur-md">
          <h2 className="font-semibold text-[#1b140f] text-lg">How to request account deletion</h2>

          <ol className="mt-6 space-y-4 text-sm text-[#4f4034] leading-7 list-decimal list-inside">
            <li>
              Send an email to{' '}
              <span className="font-medium text-[#1b140f]">fundofarmer@gmail.com</span>
            </li>

            <li>
              Use the subject line:{' '}
              <span className="font-medium text-[#1b140f]">"Account Deletion Request"</span>
            </li>

            <li>Include the email address associated with your Fundo account</li>

            <li>Provide a brief reason for deletion (optional but helps us improve)</li>

            <li>
              Attach any relevant files if necessary (e.g. verification, requests, or supporting
              documents)
            </li>
          </ol>
        </div>

        {/* Example Email */}
        <div className="mt-10 rounded-[1.75rem] border border-[#1b140f]/10 bg-[#1b140f] p-8 text-white">
          <h3 className="font-semibold text-lg">Example email</h3>

          <div className="mt-6 text-sm leading-7 text-white/80">
            <p>
              <strong>To:</strong> fundofarmer@gmail.com
            </p>
            <p>
              <strong>Subject:</strong> Account Deletion Request
            </p>

            <div className="mt-4 space-y-2">
              <p>Hello Fundo Team,</p>
              <p>I would like to request the deletion of my account associated with this email.</p>
              <p>Reason: [Optional]</p>
              <p>Please confirm once my data has been removed.</p>
              <p>Thank you.</p>
            </div>
          </div>
        </div>

        {/* Notes */}
        <div className="mt-10 text-sm text-[#4f4034] leading-7">
          <p>
            Once your request is processed, your account and associated data will be permanently
            deleted. This action cannot be undone.
          </p>

          <p className="mt-4">
            If we require additional verification, our team may contact you before completing the
            request.
          </p>
        </div>
      </section>
    </MainLayout>
  );
};
